export const BLOG_SEARCH_MIN_QUERY_LENGTH = 2;
